// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"92c9eaec","524":"189856ad","787":"e404b972"}[chunkId] + ".chunk.js";
};